export const customFieldsEndpoints = {
  getCustomFields: { method: 'get', path: '/get/{entityType}' },
  getCustomFieldValue: { method: 'get', path: '/get-entity-value/{entityId}' },
  getAllCustomFieldValues: { method: 'get', path: '/get-all-values/{entityType}' },
  getAllCustomFieldValuesPaginated: { method: 'post', path: '/get-all-values/{entityType}' },
  upsertCustomFieldValue: { method: 'post', path: '/upsert-value/{entityId}/{customFieldId}' },
  createCustomField: { method: 'post', path: '/create/{entityType}' },
  createCustomFieldAggregationRule: { method: 'post', path: '/aggregation-rules/create' },
  getAggregationTargets: { method: 'get', path: '/aggregation-rules/by-source/{id}' },
  getCustomField: { method: 'get', path: '/{id}' },
  updateCustomField: { method: 'post', path: '/update/{id}' },
  deleteCustomField: { method: 'post', path: '/delete/{id}' },
  restoreCustomField: { method: 'post', path: '/restore/{id}' },
  listIdpAttributeMappings: { method: 'get', path: '/idp-attribute-mappings' },
  createIdpAttributeMapping: { method: 'post', path: '/idp-attrubute-mapping/create' },
  deleteIdpAttributeMapping: { method: 'post', path: '/idp-attribute-mapping/delete/{id}' },
} as const
